import CopyInput from './copy-input';
import './copy-input.less';

export default CopyInput;
